/* GRI Google Trust Badge — Google-voice copy */
(function(){
  if (window.__griGtbInit) return;
  window.__griGtbInit = true;

  var BADGE_IMG = "https://cdn.shopify.com/s/files/1/0584/7410/2873/files/google_2026_best_white_ring.png?v=1779498841";
  var POPUP_IMG = "https://cdn.shopify.com/s/files/1/0584/7410/2873/files/google_2026_best_white_ring.png?v=1779498841";
  var SHOP_LINK = 'https://www.google.com/search?q=Gender+Reveal+Ideas+Australia';
  var INFO_LINK = 'https://support.google.com/business/answer/7035772?hl=en';

  var DISMISS_KEY = 'gri_gtb_dismissed_v2';
  if (sessionStorage.getItem(DISMISS_KEY) === '1') return;

  function el(tag, attrs, html){
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') e.className = attrs[k];
      else if (k.indexOf('on') === 0) e.addEventListener(k.slice(2), attrs[k]);
      else e.setAttribute(k, attrs[k]);
    }
    if (html != null) e.innerHTML = html;
    return e;
  }

  // ===== Badge =====
  var badge = el('div', { class:'gri-gtb-badge', role:'button', 'aria-label':'Voted Australia\'s Best By Google — click for details' });
  var img = el('img', { src: BADGE_IMG, alt:'Voted Australia\'s Best By Google', loading:'eager' });
  badge.appendChild(img);
  var closeBtn = el('button', { class:'gri-gtb-close', type:'button', 'aria-label':'Dismiss badge' }, '\u00d7');
  closeBtn.addEventListener('click', function(ev){
    ev.stopPropagation();
    sessionStorage.setItem(DISMISS_KEY, '1');
    badge.classList.add('gri-gtb-hidden');
    popup.classList.add('gri-gtb-hidden');
  });
  badge.appendChild(closeBtn);

  // ===== Popup — Google-voice copy =====
  var popup = el('div', { class:'gri-gtb-popup', role:'dialog', 'aria-label':'Google verified business details' });
  var SCORES = [
    ['Service', 'Superb', 10],
    ['Pricing', 'Superb', 10],
    ['Shipping', 'Superb', 10],
    ['Product Quality', 'Superb', 10],
    ['Customer Service', 'Superb', 10]
  ];
  var scoresHtml = SCORES.map(function(s){
    var pct = (s[2] / 10) * 100;
    return ''
      + '<div class="gri-gtb-score">'
      +   '<div class="gri-gtb-score-row">'
      +     '<span class="gri-gtb-score-label">' + s[0] + '</span>'
      +     '<span class="gri-gtb-score-value"><b>' + s[1] + '</b> ' + s[2] + '/10</span>'
      +   '</div>'
      +   '<div class="gri-gtb-bar"><div class="gri-gtb-bar-fill" style="width:' + pct + '%"></div></div>'
      + '</div>';
  }).join('');

  popup.innerHTML = ''
    + '<button class="gri-gtb-popup-close" type="button" aria-label="Close">\u00d7</button>'
    + '<div class="gri-gtb-popup-header">'
    +   '<img src="' + POPUP_IMG + '" alt="Voted by Google" />'
    +   '<div class="gri-gtb-title">Verified by Google<small>2026 Top Retailer \u00b7 Australia</small></div>'
    + '</div>'
    + '<div class="gri-gtb-stars">\u2605\u2605\u2605\u2605\u2605 <span>4.85 \u00b7 7,350 Google reviews</span></div>'
    + '<p class="gri-gtb-intro"><strong>Gender Reveal Ideas</strong> selected by Google as Australia\u2019s 2026 top gender reveal retailer.</p>'
    + '<div class="gri-gtb-scores">' + scoresHtml + '</div>'
    + '<a class="gri-gtb-cta" href="' + SHOP_LINK + '" target="_blank" rel="noopener nofollow">See Google business profile \u2192</a>';

  popup.querySelector('.gri-gtb-popup-close').addEventListener('click', function(){
    popup.classList.remove('open');
  });
  badge.addEventListener('click', function(){
    popup.classList.toggle('open');
  });
  document.addEventListener('click', function(ev){
    if (!popup.classList.contains('open')) return;
    if (popup.contains(ev.target) || badge.contains(ev.target)) return;
    popup.classList.remove('open');
  });

  function mount(){
    document.body.appendChild(badge);
    document.body.appendChild(popup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else { mount(); }
})();
